var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('filter-tree',{attrs:{"title":'Filter annotations:',"initial_filter":[
            {'type':27, 'value':''},
            {'type':9, 'value':'Yes'},
            {'type':11, 'value':'No'}
           ],"max_results":_vm.max_results},on:{"update":_vm.update,"load":_vm.load}})],1),_c('div',{staticClass:"col-md-9"},[_c('div',[_c('grid',{attrs:{"items":_vm.images},on:{"update_selection_asset_ids":_vm.update_selection_asset_ids,"reload":_vm.load}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }